import { useEffect, useState } from 'react'
import { useDsnApiV2 } from 'services/axios'

export const useAssetRendition = (projectId, assetId) => {
  const [{ data, loading, error }] = useDsnApiV2(`/demopilot/projects/${projectId}/assets/${assetId}/rendition`, {
    params: {
      size: 'thumbnail',
    },
  })

  const [objectUrl, setObjectUrl] = useState(null)

  useEffect(() => {
    setObjectUrl(data?.url ?? null)
  }, [data])

  return { url: objectUrl, loading, error }
}